module.exports = __webpack_public_path__ + "static/img/concierce_visual_mo.3fe4db3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/images/concierce_visual_mo.png
// module id = wK6U
// module chunks = 0